import GraphLoader from '../../components/loaders/GraphLoader';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import NoData from '../../components/common/NoData';
import PropTypes from 'prop-types';
import { graphColors } from '../../utils/constant';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload?.length > 0) {
    return (
      <div style={{ background: '#fff', padding: 8, border: '1px solid #ccc' }}>
        <p style={{ margin: 0 }}>{label}</p>
        <p style={{ margin: 0 }}>
          <strong>Total :</strong> {payload[0].payload.countText}
        </p>
      </div>
    );
  }
  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string
};

const DashboardGraph = ({ loading, data = [] }) => {
  return (
    <>
      {loading ? (
        <GraphLoader type="bar" />
      ) : !loading && data?.length > 0 ? (
        <>
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="1" vertical={false} horizontal={true} />
              <XAxis dataKey="name" axisLine={false} tickLine={false} />
              <YAxis domain={[0, 40]} axisLine={false} tickLine={false} />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'transparent' }} />
              <Bar dataKey="count" fill="#8884d8" barSize={38}>
                {(data || [])?.map((_, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={graphColors[index % graphColors.length]}
                    opacity={1}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </>
      ) : (
        <NoData title="Total Billing" subTitle="No Data Found" height={'300px'} />
      )}
    </>
  );
};

DashboardGraph.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  legendList: PropTypes.array
};

export default DashboardGraph;
